import PaymentResponseComponent from './component'

export default PaymentResponseComponent
